module.exports = __webpack_public_path__ + "static/media/ar.e405cf16.svg";